<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('vatCode.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('vatCode.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <!-- <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button> -->
          <div class="d-flex ts-space-x-3">
            <ts-input
              v-model="search"
              v-tooltip="$t('vatCode.search')"
              :placeholder="$t('vatCode.search')"
              style="width: 250px"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.vat_code }}</td>
          <td>{{ record.vat_name }}</td>
          <td class="text-right">{{ record.vat_rate }}</td>
          <td class="text-center">
            {{ record.is_inclusive ? $t('Yes') : $t('No') }}
          </td>
            <td>
            {{ record.description}}
          </td>
          <td class="text-center ts-space-x-3 ts-whitespace-no-wrap">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('vatCode.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
        width="400px"
      >
        <form-action @cancel="clearEdit" @fetchData="fetchData" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormAction from './form'
import { Errors } from 'form-backend-validation'

export default {
  name: 'vatCode',
  components: {
    FormAction
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      showForm: false
    }
  },
  computed: {
    ...mapState('setting/vatCode', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.setting.vatCode.search
      },
      set(newValue) {
        this.$store.commit('setting/vatCode/SET_SEARCH', newValue)
        this.$store.commit('setting/vatCode/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('vatCode.code'),
          style: 'white-space: nowrap;width :300px;'
        },
        { name: this.$t('vatCode.vatName') },
        { name: this.$t('vatCode.vatRate'), style: 'text-align: right;' },
        { name: this.$t('vatCode.isInclusive'), style: 'text-align: center;' },
        { name: this.$t('vatCode.description')},
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('setting/vatCode/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.$store.commit('setting/vatCode/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit() {
      this.$store.commit('setting/vatCode/SET_EDIT_DATA', {})
      this.showForm = false
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('setting/vatCode/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
